type Destination = {
    path: string
    label: string
    heading: string
    collection?: 'jobs' | 'projects' | 'mentors' | 'volunteers' | 'skills'
}

/** Accept legacy lowercase links as well as OverviewType query values. */
export function getUnavailableDestination(type: unknown): Destination {
    switch (typeof type === 'string' ? type.toUpperCase() : '') {
        case 'JOBS':
            return {
                path: '/praca',
                label: 'Pozrieť aktuálne pracovné ponuky',
                heading: 'Ďalšie pracovné ponuky, ktoré by ťa mohli zaujímať',
                collection: 'jobs'
            }
        case 'VOLUNTEERING':
            return {
                path: '/dobrovolnictvo/dobrovolnicke-projekty',
                label: 'Pozrieť dobrovoľnícke projekty',
                heading: 'Ďalšie dobrovoľnícke príležitosti',
                collection: 'projects'
            }
        case 'VOLUNTEERS':
            return {
                path: '/dobrovolnictvo/dobrovolnici',
                label: 'Pozrieť dobrovoľníkov',
                heading: 'Ďalší dobrovoľníci',
                collection: 'volunteers'
            }
        case 'MENTORING':
            return {
                path: '/mentori',
                label: 'Nájsť ďalších mentorov',
                heading: 'Mentori, ktorí by ťa mohli zaujímať',
                collection: 'mentors'
            }
        case 'SKILLS':
            return {
                path: '/vzdelavanie',
                label: 'Pozrieť vzdelávacie príležitosti',
                heading: 'Ďalšie vzdelávacie príležitosti',
                collection: 'skills'
            }
        default:
            return { path: '/', label: 'Pozrieť aktuálne príležitosti', heading: '' }
    }
}
